if ( typeof LocalizationForm !== 'function' ) {
	class LocalizationForm extends HTMLElement {

		constructor(){

			super();

			this.selector = this.querySelector('[data-js-localization-form-button]');
			this.content = this.querySelector('[data-js-localization-form-content]');
			this._prefix = window.KT_PREFIX || '';

			if ( this.selector ) {

				if ( this.querySelector('[data-js-localization-form-insert-helper-content]') ) {
					
					this.selector.addEventListener('click', e=>{
						if ( ! this.classList.contains('populated') ) {
							this.classList.add('populate');
							this.populate();
						}
					})

				}

				this.selector.addEventListener('click', e=>{

					e.stopPropagation();
					e.preventDefault();

					document.querySelectorAll(`[data-js-localization-form-content].${this._prefix}content-opened`).forEach(elm=>{
						if ( elm != e.currentTarget.parentNode.querySelector('[data-js-localization-form-content]') ) {
							elm.classList.remove(`${this._prefix}content-opened`);
							elm.parentNode.style.zIndex = 9;
						}
					});

					if ( ! this.content.classList.contains(`${this._prefix}content-opened`) ) {

						this.content.classList.add(`${this._prefix}content-opened`);
						e.currentTarget.setAttribute('aria-expanded', 'true');
						this.content.parentNode.style.zIndex = 1000;;
						
						if ( this.content.getBoundingClientRect().y + this.content.offsetHeight + 55 > window.innerHeight ) {
							this.content.classList.add(`${this._prefix}invert-y`);
						}
						if ( this.content.getBoundingClientRect().x + this.content.offsetWidth + 55 > window.innerWidth ) {
							this.content.classList.add(`${this._prefix}invert-x`);
						}

						this.onClickHandler = (()=>{
							if ( this.content.classList.contains(`${this._prefix}content-opened`) ) {
								this.content.classList.remove(`${this._prefix}content-opened`, `${this._prefix}invert-x`, `${this._prefix}invert-y`);
								this.content.parentNode.style.zIndex = 9;
							}
						}).bind(this);
						window.addEventListener('click', this.onClickHandler);

					} else {
						e.currentTarget.setAttribute('aria-expanded', 'false');
						this.content.parentNode.style.zIndex = 9;
						this.content.classList.remove(`${this._prefix}content-opened`, `${this._prefix}invert-x`, `${this._prefix}invert-y`);
						window.removeEventListener('click', this.onClickHandler);
					}

				});

				this.querySelector('[data-js-localization-form-button]').addEventListener('keydown', e=>{
					if ( e.keyCode == window.KEYCODES.RETURN ) {
						if ( ! this.content.classList.contains(`${this._prefix}opened-with-tab`) ) {
							this.content.classList.add(`${this._prefix}opened-with-tab`);
							this.content.querySelectorAll('[data-js-localization-form-item]').forEach(elm=>{elm.setAttribute('tabindex', '0')});
						}
					}
				});

			}

		}

		populate() {
			fetch('?section_id=helper-localization-form').then(response=>response.text())
				.then(text => {
					const results = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-helper-localization-form').innerHTML;
					this.querySelector('[data-js-localization-form-insert-helper-content]').innerHTML = results;
					if ( this.content.getBoundingClientRect().y + this.content.offsetHeight + 55 > window.innerHeight ) {
						this.content.classList.add(`${this._prefix}invert-y`);
					}
					if ( this.content.getBoundingClientRect().x + this.content.offsetWidth + 55 > window.innerWidth ) {
						this.content.classList.add(`${this._prefix}invert-x`);
					}
				})
				.catch(e=>{
					console.log(e);
				})
		}

	}

	if ( typeof customElements.get('localization-form') == 'undefined' ) {
		customElements.define('localization-form', LocalizationForm);
	}

}

(()=>{
	const marketPriorityForms = document.querySelectorAll('.localization-form--market-priority');

	// Target-market locale map (aligned with localization-form.liquid).
	// Primary candidate wins; data-preferred-locale is used only if it matches.
	const localeCandidatesByCountry = {
		IT: ['it-it', 'it-eu', 'it'],
		FR: ['fr-fr', 'fr-eu', 'fr'],
		DE: ['de-eu', 'de'],
		ES: ['es-eu', 'es'],
		GB: ['en-uk', 'en-gb', 'en'],
		UK: ['en-uk', 'en-gb', 'en'],
		CA: ['en-ca', 'en'],
		AU: ['en-au', 'en'],
		US: ['en-us', 'en']
	};
	const defaultLocaleCandidates = ['en-eu', 'en-int', 'en'];

	const isItalianLocale = (code)=>{
		const normalized = (code || '').toLowerCase().replace('_', '-');
		return normalized === 'it' || normalized.indexOf('it-') === 0;
	};

	marketPriorityForms.forEach(form=>{
		// Official Shopify field is language_code (locale_code is ignored).
		let languageInput = form.querySelector('input[name="language_code"]');
		if ( !languageInput ) {
			const legacyInput = form.querySelector('input[name="locale_code"]');
			if ( legacyInput ) {
				legacyInput.setAttribute('name', 'language_code');
				languageInput = legacyInput;
			}
		}
		const countryFlags = form.querySelectorAll('[data-country-flag]');
		const countryButtons = ()=>form.querySelectorAll('[data-country-code]');

		const toFlagEmoji = (countryCode)=>{
			const iso = (countryCode || '').toUpperCase();
			if ( !/^[A-Z]{2}$/.test(iso) ) return '';
			const codePoints = Array.from(iso).map(char=>127397 + char.charCodeAt(0));
			return String.fromCodePoint(...codePoints);
		};

		countryFlags.forEach(flagNode=>{
			const countryCode = flagNode.getAttribute('data-country-flag');
			const flag = toFlagEmoji(countryCode);
			if ( flag ) {
				flagNode.textContent = flag;
			}
		});

		if ( !languageInput ) return;

		const applyPreferredLanguage = button=>{
			if ( !button ) return;
			const countryCode = (button.getAttribute('data-country-code') || '').toUpperCase();
			const candidates = localeCandidatesByCountry[countryCode] || defaultLocaleCandidates;
			const fromAttr = (button.getAttribute('data-preferred-locale') || '').toLowerCase().replace('_', '-');

			// Always use the mapped primary locale for the *target* country.
			let preferredLanguage = candidates[0] || (countryCode === 'IT' ? 'it' : 'en');

			// Accept data-preferred-locale only if it belongs to this country's candidates.
			if ( fromAttr && candidates.indexOf(fromAttr) !== -1 ) {
				preferredLanguage = fromAttr;
			}

			// Never keep Italian outside the IT market.
			if ( countryCode !== 'IT' && isItalianLocale(preferredLanguage) ) {
				preferredLanguage = candidates[0] || 'en';
			}

			languageInput.value = preferredLanguage;
		};

		countryButtons().forEach(button=>{
			button.addEventListener('click', ()=>{
				applyPreferredLanguage(button);
			});
		});

		// Safety net: if click handlers are skipped (mobile/dynamic DOM),
		// ensure language_code is still aligned before submit.
		form.addEventListener('submit', event=>{
			const submitter = event.submitter;
			if ( submitter && submitter.matches('[data-country-code]') ) {
				applyPreferredLanguage(submitter);
			}
		});
	});
})();